/*** Estimated delivery date (Schuyler / America/Chicago business days).*/
(function () {
  'use strict';

  var VARIANT_DATA_ID = 'availability-variant-data';
  var TEMPLATE_ID = 'estimated-delivery-template';
  var DATE_ATTR = 'data-edd-date';
  var variantsCache = null;
  var variantMapCache = null;
  var variantsCacheSignature = null;
  var cachedVariantId = null;
  var cachedVariant = null;
  var deliveryElement = null;
  var deliveryDateCache = null;
  var deliveryDateTimestamp = 0;
  var deliveryFormatter = new Intl.DateTimeFormat('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
  var dom = {
    leadTime: null,
    variantInput: null,
    template: null,
    target: null,
    backorderInput: null,
  };

  function cacheDom() {
    dom.leadTime = document.getElementById('product__lead-time-msg-container');
    dom.variantInput = document.querySelector('input.product-variant-id');
    dom.template = document.getElementById(TEMPLATE_ID);
    dom.target = document.querySelector('.quantity-buy-buttons-wrapper');
    dom.backorderInput = document.querySelector('[data-backorder-flag]');
  }

  function refreshDomIfStale() {
    if (
      (dom.leadTime && !dom.leadTime.isConnected) ||
      (dom.variantInput && !dom.variantInput.isConnected) ||
      (dom.target && !dom.target.isConnected) ||
      (dom.template && !dom.template.isConnected) ||
      !dom.leadTime ||
      !dom.variantInput ||
      !dom.target
    ) {
      cacheDom();
      cachedVariantId = null;
      cachedVariant = null;
      if (deliveryElement && !deliveryElement.isConnected) {
        deliveryElement = null;
      }
    }
  }

  function removeEstimatedDelivery() {
    var list = document.querySelectorAll('.estimated-delivery');
    for (var i = 0; i < list.length; i++) {
      if (list[i] === deliveryElement) deliveryElement = null;
      list[i].remove();
    }
  }

  // Convert still injects the old-theme Est. Delivery markup (no data-edd-date).
  // Keep only the theme-owned block.
  function isThemeEstimatedDelivery(el) {
    return !!(el && (el === deliveryElement || el.querySelector('[' + DATE_ATTR + ']')));
  }

  function removeForeignEstimatedDelivery() {
    var all = document.querySelectorAll('.estimated-delivery');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (isThemeEstimatedDelivery(el)) continue;
      el.remove();
    }
  }

  function ensureLeadTimeMessageVisible() {
    refreshDomIfStale();
    var leadTimeContainer = dom.leadTime;
    if (!leadTimeContainer) return;
    if (!leadTimeContainer.querySelector('#product__lead-time-msg-text, .backorder-title, .backorder')) {
      return;
    }
    if (leadTimeContainer.style.getPropertyValue('display') === 'block') return;
    leadTimeContainer.style.setProperty('display', 'block', 'important');
  }

  function enforceBackorderLeadTimeUi() {
    removeEstimatedDelivery();
    ensureLeadTimeMessageVisible();
  }

  function hasForeignEstimatedDelivery() {
    var all = document.querySelectorAll('.estimated-delivery');
    for (var i = 0; i < all.length; i++) {
      if (!isThemeEstimatedDelivery(all[i])) return true;
    }
    return false;
  }

  function handleBlockedEddMutations() {
    if (isBackorderedOrOutOfStock()) {
      var hasEdd = !!document.querySelector('.estimated-delivery');
      var lead = dom.leadTime;
      var leadHidden =
        lead &&
        lead.querySelector('#product__lead-time-msg-text, .backorder-title, .backorder') &&
        lead.style.getPropertyValue('display') !== 'block' &&
        window.getComputedStyle(lead).display === 'none';

      if (!hasEdd && !leadHidden) return;
      enforceBackorderLeadTimeUi();
      return;
    }

    // In-stock: strip Convert duplicate Est. Delivery clones only.
    if (hasForeignEstimatedDelivery()) {
      removeForeignEstimatedDelivery();
    }
  }

  function ensureBlockedEddObserver() {
    if (window.__eddBlockedObserverBound) return;

    refreshDomIfStale();
    var leadTimeContainer = dom.leadTime;
    var target = dom.target;
    // Est. Delivery is injected as a sibling near buy buttons, not inside the
    // lead-time container — observe the shared parent for inserts, and the
    // lead-time node for A/B style/class hides.
    var observeRoot = (target && target.parentNode) || (leadTimeContainer && leadTimeContainer.parentNode);
    if (!observeRoot && !leadTimeContainer) return;

    window.__eddBlockedObserverBound = true;

    var rafPending = false;
    var observer = new MutationObserver(function () {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        handleBlockedEddMutations();
      });
    });

    if (observeRoot) {
      observer.observe(observeRoot, { childList: true, subtree: true });
    }
    if (leadTimeContainer) {
      observer.observe(leadTimeContainer, {
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
    }
  }

  function getVariantDataSignature() {
    var jsonScript = document.getElementById(VARIANT_DATA_ID);
    return jsonScript ? jsonScript.textContent : '';
  }

  function getVariants() {
    var signature = getVariantDataSignature();
    if (variantsCache && signature === variantsCacheSignature) {
      return variantsCache;
    }

    variantsCacheSignature = signature;
    cachedVariantId = null;
    cachedVariant = null;

    if (!signature) {
      variantsCache = [];
      variantMapCache = {};
      return variantsCache;
    }

    try {
      variantsCache = JSON.parse(signature) || [];
    } catch (e) {
      variantsCache = [];
    }

    variantMapCache = {};
    for (var i = 0; i < variantsCache.length; i++) {
      variantMapCache[String(variantsCache[i].id)] = variantsCache[i];
    }

    return variantsCache;
  }

  function getCurrentVariant() {
    getVariants();
    refreshDomIfStale();
    var variantInput = dom.variantInput;
    if (!variantInput || !variantMapCache) return null;

    var id = String(variantInput.value);
    if (id === cachedVariantId) return cachedVariant;

    cachedVariantId = id;
    cachedVariant = variantMapCache[id] || null;
    return cachedVariant;
  }

  function isBackorderedOrOutOfStock() {
    refreshDomIfStale();
    var leadTimeContainer = dom.leadTime;
    if (leadTimeContainer && leadTimeContainer.querySelector('.backorder-title, .backorder')) {
      return true;
    }

    var backorderInput = dom.backorderInput;
    if (
      backorderInput &&
      backorderInput.getAttribute('name') === 'properties[Backordered]' &&
      backorderInput.value
    ) {
      return true;
    }

    var current = getCurrentVariant();
    if (!current) return false;

    return current.inventory_management === 'shopify' && Number(current.inventory_quantity) <= 0;
  }

  function addBusinessDays(date, days) {
    var result = new Date(date);
    var addedDays = 0;
    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      var dayOfWeek = result.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) addedDays++;
    }
    return result;
  }

  function computeDeliveryDate() {
    var nowMs = Date.now();
    if (deliveryDateCache && nowMs - deliveryDateTimestamp < 60000) {
      return deliveryDateCache;
    }

    // Match previous behavior: interpret "now" in America/Chicago
    var now = new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' });
    var currentDate = new Date(now);
    var day = currentDate.getDay();
    var hour = currentDate.getHours();
    var isBefore2pm = hour < 14;

    var shipDate = new Date(currentDate);
    if (day === 5 && !isBefore2pm) {
      shipDate.setDate(shipDate.getDate() + 3);
    } else if (day === 6) {
      shipDate.setDate(shipDate.getDate() + 2);
    } else if (day === 0) {
      shipDate.setDate(shipDate.getDate() + 1);
    } else if (!isBefore2pm) {
      do {
        shipDate.setDate(shipDate.getDate() + 1);
      } while (shipDate.getDay() === 0 || shipDate.getDay() === 6);
    }

    deliveryDateCache = addBusinessDays(shipDate, 3);
    deliveryDateTimestamp = nowMs;
    return deliveryDateCache;
  }

  function formatDeliveryDate(date) {
    return deliveryFormatter.format(date);
  }

  function updateDeliveryDateText(container) {
    var dateEl = container.querySelector('[' + DATE_ATTR + ']');
    if (dateEl) {
      dateEl.textContent = 'Est. Delivery: ' + formatDeliveryDate(computeDeliveryDate());
    }
  }

  function renderEstimatedDelivery() {
    if (isBackorderedOrOutOfStock()) {
      enforceBackorderLeadTimeUi();
      ensureBlockedEddObserver();
      return;
    }

    refreshDomIfStale();
    var target = dom.target;
    var template = dom.template;
    if (!target || !target.parentNode || !template) {
      removeEstimatedDelivery();
      return;
    }

    if (deliveryElement && deliveryElement.isConnected) {
      updateDeliveryDateText(deliveryElement);
      removeForeignEstimatedDelivery();
      ensureBlockedEddObserver();
      return;
    }

    removeEstimatedDelivery();

    var node = template.content.cloneNode(true);
    deliveryElement = node.querySelector('.estimated-delivery');
    if (!deliveryElement) return;

    updateDeliveryDateText(deliveryElement);
    target.parentNode.insertBefore(deliveryElement, target);
    removeForeignEstimatedDelivery();
    ensureBlockedEddObserver();
  }

  function bindVariantChange() {
    if (window.__deliveryTimingVariantBound) return true;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, renderEstimatedDelivery);
      window.__deliveryTimingVariantBound = true;
      return true;
    }

    return false;
  }

  function ensureVariantChangeBound(attemptsLeft) {
    if (bindVariantChange() || attemptsLeft <= 0) return;
    setTimeout(function () {
      ensureVariantChangeBound(attemptsLeft - 1);
    }, 100);
  }

  window.renderEstimatedDelivery = renderEstimatedDelivery;

  function start() {
    cacheDom();
    ensureVariantChangeBound(20);
    renderEstimatedDelivery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
